import { user_permissions } from "../data/constants/permissions";

export function getPermission(type, name) {
  return user_permissions[type].find((item) => item.name === name).permission;
}
